import React, { useState } from 'react';

// Import demo components - these should match the registry in CaseStudyModal
import MedDRADemo from './MedDRADemo';
// import AnotherDemo from './AnotherDemo';

// Map case study IDs to their demo components
const demoRegistry = {
  'meddra-autocoder': MedDRADemo,
  // 'another-case-study': AnotherDemo,
};

export default function CaseStudyCard({ caseStudy, onOpenModal }) {
  const [showDemo, setShowDemo] = useState(false);
  
  // Get demo component if one exists for this case study
  const DemoComponent = caseStudy.hasInteractiveDemo ? demoRegistry[caseStudy.id] : null;

  return (
    <div className="border-2 border-black p-8 bg-white shadow-[8px_8px_0px_0px_rgba(0,0,0,1)] hover:shadow-[10px_10px_0px_0px_rgba(0,0,0,1)] hover:translate-x-[-2px] hover:translate-y-[-2px] transition-all rounded-lg">
      <div className="flex items-start justify-between mb-4">
        <div>
          <h3 className="text-2xl font-black mb-2">{caseStudy.title}</h3>
          <p className="text-sm text-neutral-600">
            {caseStudy.role} | {caseStudy.timeline}
          </p>
        </div>
      </div>
      
      <p className="text-base leading-relaxed mb-4">
        {caseStudy.summary}
      </p>

      <p className="text-sm leading-relaxed mb-6 text-neutral-700">
        <strong>The Problem:</strong> {caseStudy.problem}
      </p>

      <div className="mb-6">
        <h4 className="font-bold text-sm mb-3">Key Results</h4>
        <div className="flex flex-wrap gap-3">
          {caseStudy.metrics.map((metric, i) => (
            <span key={i} className="px-4 py-2 bg-sky-200 border-2 border-black font-bold text-sm rounded-md">
              {metric}
            </span>
          ))}
        </div>
      </div>

      <div className="mb-6">
        <h4 className="font-bold text-sm mb-2">Skills Demonstrated</h4>
        <div className="flex flex-wrap gap-2">
          {caseStudy.skills.map((skill, i) => (
            <span key={i} className="px-3 py-1 bg-neutral-100 border border-black text-xs font-medium rounded">
              {skill}
            </span>
          ))}
        </div>
      </div>

      {/* Interactive Demo Section - only shows if demo exists */}
      {DemoComponent && showDemo && (
        <div className="mb-6">
          <DemoComponent />
        </div>
      )}

      <div className="flex gap-3">
        {DemoComponent && (
          <button
            onClick={() => setShowDemo(!showDemo)}
            className="px-6 py-3 bg-emerald-500 text-white font-bold border-2 border-black hover:bg-emerald-600 transition-colors rounded-md"
          >
            {showDemo ? 'Hide Demo' : 'Launch Demo →'}
          </button>
        )}
        <button
          onClick={() => onOpenModal(caseStudy)}
          className="px-6 py-3 bg-black text-white font-bold border-2 border-black hover:bg-neutral-800 transition-colors rounded-md"
        >
          Read Full Case Study →
        </button>
      </div>
    </div>
  );
}